<div class="container">
  <div class="container__section container__section_navigation">
    <nav
      class="navigation"
      (mouseenter)="onMouseenter()"
      (mouseleave)="onMouseleave()"
    >
      <app-topbar
        class="navigation-topbar"
        (topbarHeightChange)="topbarHeightChange.next($event)"
      ></app-topbar>
      <div
        class="navigation-book-button"
        *ngIf="!environment.production"
      >
        <app-book-button [booksList]="userService.booksList"></app-book-button>
      </div>

      <div
        class="navigation-time-button"
        *ngIf="!environment.production"
      >
        <app-time-button></app-time-button>
      </div>

      <div class="navigation-bar">
        <div class="navigation-bar__items navigation-bar__items_start">
          <button
            fxHide.gt-lg
            class="navigation-button"
            (click)="menuToggle()"
          >
            <div class="navigation-button__icon">
              <div
                class="icon-menu"
                [ngClass]="{
                  active: isMenuActive
                }"
              >
                <div class="sw-topper"></div>
                <div class="sw-bottom"></div>
                <div class="sw-footer"></div>
              </div>
            </div>
          </button>
          <!-- <app-navigation-item
            fxHide.lt-xl
            title="About"
            [link]="ROUTE_PATH_ABOUT"
          ></app-navigation-item> -->
          <app-navigation-item
            fxHide.lt-xl
            title="Books"
            [children]="booksChildren"
          ></app-navigation-item>
          <app-navigation-item
            fxHide.lt-xl
            title="FAQ"
            [link]="ROUTE_PATH_FAQ"
          ></app-navigation-item>
        </div>
        <div class="navigation-bar__logo">
          <a
            class="navigation-logo"
            [routerLink]="ROUTE_PATH_INDEX"
          >
            <app-logo></app-logo>
          </a>
        </div>
        <div class="navigation-bar__items navigation-bar__items_end">
          <app-navigation-item
            fxHide.lt-xl
            title="Contact"
            [link]="ROUTE_PATH_CONTACTS"
          ></app-navigation-item>
          <app-location-picker></app-location-picker>
          <!-- <app-navigation-item
            [title]="getIconItemText('@BUKI')"
            [href]="LINK_INSTAGRAM"
            svgIconSrc="assets/images/icons/instagram.svg"
            target="_blank"
          ></app-navigation-item> -->
          <app-navigation-item
            *ngIf="headerService.isCartVisible"
            [title]="getIconItemText('Cart')"
            [link]="ROUTE_PATH_CART"
            svgIconSrc="assets/images/icons/cart.svg"
            [label]="userService.booksInCartList.length"
          ></app-navigation-item>
        </div>
      </div>
    </nav>
  </div>
  <div class="container__section container__section_menu">
    <div
      class="backdrop"
      [class.backdrop_active]="isMenuActive"
      (click)="onBackdropClick()"
      (touchstart)="onBackdropClick()"
    ></div>
    <div
      class="menu"
      [class.menu_active]="isMenuActive"
      fxHide.gt-lg
      (mouseenter)="onMouseenter()"
      (mouseleave)="onMouseleave()"
    >
      <!-- <app-menu-item
        class="menu__item"
        title="About BÜKI"
        [link]="ROUTE_PATH_ABOUT"
      ></app-menu-item> -->
      <app-menu-item
        class="menu__item"
        title="Books"
        [children]="booksChildren"
      ></app-menu-item>
      <app-menu-item
        class="menu__item"
        title="FAQ"
        [link]="ROUTE_PATH_FAQ"
      ></app-menu-item>
      <!-- <app-menu-item
        class="menu__item"
        title="Blog"
        href="https://hellobuki.com/jp/blog"
      ></app-menu-item> -->
      <!-- <app-menu-item
        class="menu__item"
        title="About BÜKI"
        [link]="ROUTE_PATH_ABOUT"
      ></app-menu-item> -->
      <app-menu-item
        class="menu__item"
        title="Contact"
        [link]="ROUTE_PATH_CONTACTS"
      ></app-menu-item>
    </div>
  </div>
</div>

<!-- <mat-menu #menu="matMenu">
  <button mat-menu-item>About BÜKI</button>
  <button mat-menu-item routerLink="/faq">FAQ</button>
  <button mat-menu-item>Contact Us</button>

  <button mat-menu-item routerLink="/404">404</button>

  <button mat-menu-item *ngFor="let bookItem of userService.booksList" routerLink="/book/{{bookItem.bookId}}">
    {{bookItem.heroName}} {{bookItem.bookId}}
  </button>
</mat-menu> -->
